import { axios } from '@/utils/request'

const api = {
    cpjlgradelist: '/wyhadminapi/cha/cpjlgradelist', 
 
}

export default api

export function cpjlgradelist(parameter) {
  return axios({
    url: api.cpjlgradelist,
    method: 'get',
    params: parameter
  })
}
 